import { render, staticRenderFns } from "./ChatMessageMain.vue?vue&type=template&id=35283fa8&scoped=true&"
import script from "./ChatMessageMain.vue?vue&type=script&lang=js&"
export * from "./ChatMessageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35283fa8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatAvatar: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatAvatar.vue').default,ChatEmoji: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatEmoji.vue').default})
